/**
 * Premium Badge Component
 * Small labeled elements with glassmorphism
 */

export const Badge = ({
    children,
    variant = 'default',
    size = 'md',
    className = ''
}) => {
    const variants = {
        default: 'bg-white/20 text-gray-700 border-white/30',
        primary: 'bg-gradient-to-r from-[var(--accent-primary)] to-[var(--accent-secondary)] text-white border-white/30',
        success: 'bg-gradient-to-r from-green-500 to-green-600 text-white border-white/30',
        warning: 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white border-white/30',
        danger: 'bg-gradient-to-r from-red-500 to-red-600 text-white border-white/30',
        info: 'bg-gradient-to-r from-blue-500 to-blue-600 text-white border-white/30',
        purple: 'bg-gradient-to-r from-purple-500 to-purple-600 text-white border-white/30',
        pink: 'bg-gradient-to-r from-pink-500 to-pink-600 text-white border-white/30',
    }

    const sizes = {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-3 py-1 text-sm',
        lg: 'px-4 py-1.5 text-base'
    }

    return (
        <span
            className={`
        inline-flex items-center gap-1
        font-semibold rounded-full
        backdrop-blur-sm border
        shadow-sm
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
        >
            {children}
        </span>
    )
}

/**
 * Premium Status Badge
 * For status indicators (active, pending, etc.)
 */
export const StatusBadge = ({ status, className = '' }) => {
    const statusConfig = {
        active: { label: 'Actief', variant: 'success' },
        pending: { label: 'In afwachting', variant: 'warning' },
        completed: { label: 'Voltooid', variant: 'info' },
        cancelled: { label: 'Geannuleerd', variant: 'danger' },
        draft: { label: 'Concept', variant: 'default' }
    }

    const config = statusConfig[status] || statusConfig.draft

    return (
        <Badge variant={config.variant} className={className}>
            {config.label}
        </Badge>
    )
}
